export default {
  zh: {
    intitle: "公司取名",
    postfix: "请选择公司名称的后缀",
    businessExplain: "我们将按选项的顺序测试公司名称是否可以申请到。请不要在提议的实体名称中包含任何后缀，例如:Ptd. Ltd., Limited, LLP。",
    shortBusinessExplain: "我们将按选项的顺序测试公司名称是否可以申请到。",
    companyType: "公司类型",
    companyTypeLower: "公司类型",
    companyTypeTip: "若公司股东含有公司实体和/或超过20名，须选择: ",
    companyTypeRule: "若公司股东含有公司实体和/或超过20名，须选择: Private Company Limited by Shares / 私人股份有限公司",
    companyNameTitle: "公司名称(只能以英文取名)",
    companyName01: "公司名(第1选项)",
    companyName02: "公司名(第2选项)",
    companyName03: "公司名(第3选项)",
    main: "主营业务",
    mainDescribe: "主营业务具体描述",
    minor: "次营业务",
    minorDescribe: "次营业务具体描述",
    commonDescribe: "需英文输入",
    detailsTitle: "股东/董事信息",
    detailsTitleLower: "股东/董事信息",
    addButton: "添加股东/董事",
    caution: "至少有1名董事的常住地须为新加坡",
    check: "我们同意聘用由星中商务推荐的名义董事1名，我们也理解该名义董事的行为造成的任何法律影响均与EStar无关。",
    reminder: "写明董事需要几位,SG的要几位 - Stella follow",
    type01: "股东",
    type02: "董事",
    type03: "股东+董事",
    addCompany: "添加公司",
    addPersonal: "添加个人",
    licenseName: "姓名(跟营业执照上的一致)",
    country: "国家",
    license: "营业执照号码",
    phone: "手机号码",
    email: "邮箱地址",
    site: "公司注册地址",
    location: "营运地址",
    stock: "股票类型",
    stockOption01: "Ordinary 普通股",
    stockOption02: "Preference 优先股",
    stockOption03: "Others 其他",
    theFundsName: "相关基金",
    ratio: "所占股份数量",
    capital: "注册资本",
    paidInCapital: "实收资本",
    hold: "以信托方式持有股份",
    trust: "信托名称（若适用）",
    representative: "主体代表",
    cardName: "姓名(跟证件一致)",
    nationality: "国籍",
    cardType: "身份证件类型",
    cardNo: "身份证件号码",
    address: "住址",
    type: "类型",
    compellation: "姓名",
    aggregate: "所占股份数量(总计)",
    identityType01: "NRIC (Citizen) 新加坡公民身份证号",
    identityType02: "NRIC (Permanent Resident) 新加坡永久居民身份证号",
    identityType03: "FIN 新加坡工作证准号",
    identityType04: "Passport/Others 护照号/其他",
    incorporationDate: "公司注册日期",
    birthDate: "出生日期",
    suggest: "建议英文输入，若输入为中文，相关英文翻译将由星中商务自行完成",
    isNomineeShareholder: "股东是否为挂名股东",
    isNomineeDirector: "董事是否为挂名董事",
    isTenderResignation: "董事是否需要辞任",
    isHasPrcInland: "是否在中国大陆公司持有股份",
    prcInlandName: "持有股份的中国公司名称(请提供1家)",
    practical: "实收资本",
  },
  en: {
    intitle: "Company Name",
    postfix: "Please select the suffix of the company name",
    businessExplain:
      "We will follow the option sequence of proposed entity name to check whether such name can be applied in Gov's system. Please do not include any suffix in the proposed entity name e.g. Pte. Ltd., Limited, LLP. ",
    shortBusinessExplain: "We will follow the option sequence of proposed entity name to check whether such name can be applied in Gov's system",
    companyType: "Company Type",
    companyTypeLower: "Company type",
    companyTypeTip: "If the company's shareholders include corporate entities and/or more than 20 shareholders, you must select:",
    companyTypeRule: "If the company's shareholders include corporate entities and/or more than 20 shareholders, you must select: Private Company Limited by Shares",
    companyNameTitle: "Proposed Company Name (English Only)",
    companyName01: "Company name (Option 1)",
    companyName02: "Company name (Option 2)",
    companyName03: "Company name (Option 3)",
    main: "Primary activity",
    mainDescribe: "Primary User-Described Activity Description",
    minor: "Secondary activity",
    minorDescribe: "Secondary User-Described Activity Description",
    commonDescribe: "English only",
    detailsTitle: "Officer Details - Shareholder(s)/Director(s)",
    detailsTitleLower: "Officer details - shareholder(s)/directors(s)",
    addButton: "Add shareholder/director",
    caution: "At lease one director's permanent residence must be in Singapore (i.e. either a Singaporean or SG PR).",
    check:
      'We consent to appoint one Nominee Director recommended by EStar Business Services Pte. Ltd. ("EStar"), and we understand that any legal impact caused by the Nominee Director\'s action has nothing to do with EStar.',
    reminder: "Tell us how many directors we need, how many SG people we need - Stella follow",
    type01: "Shareholder",
    type02: "Director",
    type03: "Shareholder+Director",
    addCompany: "Add Company",
    addPersonal: "Add Individual",
    licenseName: "Name (same as business certificate)",
    country: "Country",
    license: "Business No.",
    phone: "Mobile",
    email: "Email",
    site: "Registered address",
    location: "Operation address",
    stock: "Type of shares",
    stockOption01: "Ordinary",
    stockOption02: "Preference",
    stockOption03: "Others",
    theFundsName: "Related fund(s)",
    ratio: "No of shares allotted",
    capital: "Amount of registered share capital",
    paidInCapital: "Paid-up capital",
    hold: "Shares held in trust",
    trust: "Name of the trust (if applicable)",
    representative: "Representative",
    cardName: "Name (same as IC)",
    nationality: "Nationality",
    cardType: "Identification type",
    cardNo: "Identification No.",
    address: "Residential address",
    type: "Type",
    compellation: "Name",
    aggregate: "No of shares allotted (total)",
    identityType01: "NRIC (Citizen)",
    identityType02: "NRIC (Permanent Resident)",
    identityType03: "FIN",
    identityType04: "Passport/Others",
    incorporationDate: "Incorporation date",
    birthDate: "Birth date",
    suggest: "Only English and Chinese is accepted. If the input is in Chinese, EStar will complete the English translation on its own.",
    isNomineeShareholder: "Is the shareholder a Nominee Shareholder?",
    isNomineeDirector: "Is the director a Nominee Director?",
    isTenderResignation: "Will the director tender resignation?",
    isHasPrcInland: "Does the individual hold share interest of any entity in PRC inland?",
    prcInlandName: "Please provide the name of RPC entity (1 entity is required)",
    practical: "Paid-up capital",
  },
};
